/**
 * Component: Quick Add
 * ------------------------------------------------------------------------------
 * A quick add file that contains scripts to function.
 *
 * @namespace quickAdd
 */
import ProductForm from './product-form';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-quick-add="container"]',
};

/**
 * Create a new quick add object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelectorAll(selectors.container),
  };


  /**
   * Initialise component.
   */
  function init() {
    createQuickAddForms();
  }

  /**
   * Loop through all forms
   */
  function createQuickAddForms() {
    [...nodeSelectors.container].forEach((item) => {
      const namespace = item.dataset.namespace;

      ProductForm({
        container: namespace,
        enableSwatches: true,
      }).init();
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
